import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import Base from './Base';
import classNames from './Loading.scss';

export default class Loading extends Component {
  render() {
    return (
      <Base className={classNames.loadingWidget}>
        <CircularProgress />
      </Base>
    );
  }
}
